import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=72ea93c2&scoped=true"
import script from "./solution.vue?vue&type=script&lang=js"
export * from "./solution.vue?vue&type=script&lang=js"
import style0 from "./solution.vue?vue&type=style&index=0&id=72ea93c2&prod&lang=css"
import style1 from "./solution.vue?vue&type=style&index=1&id=72ea93c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea93c2",
  null
  
)

export default component.exports